import clsx from "clsx";
import React, { useEffect, useState } from "react";
import RecruiterSelector from "../Auditions/RecruiterSelector";
import { useSelector } from "react-redux";

const SlideStack = ({ components, open, showRecruiter = false }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedParams, setSelectedParams] = useState(0);

  const loading = useSelector((state) => state.projectReducer.loading);

  const route = components?.find((_, index) => index === selectedIndex)?.name;

  useEffect(() => {
    setSelectedIndex(0);
    setSelectedParams({});
  }, [open]);

  const scrollToTop = () => {
    setTimeout(() => {
      document.getElementById("top").scrollIntoView();
    }, 500);
  };

  const goBack = () => {
    if (selectedIndex > 0) setSelectedIndex(selectedIndex - 1);
    setSelectedParams({});
    scrollToTop();
  };

  const goNext = () => {
    if (selectedIndex < components?.length - 1)
      setSelectedIndex(selectedIndex + 1);
    setSelectedParams({});
    scrollToTop();
  };

  const navigate = (componentName, params = {}) => {
    const index = components?.findIndex((a) => a.name === componentName);
    if (index !== -1) {
      setSelectedIndex(index);
      setSelectedParams(params);
    }
    scrollToTop();
  };

  const renderComponent = (item, index) => {
    const MyComponent = item["component"];
    return (
      <div
        id="top"
        className={clsx(
          "transition-transform ease-in-out duration-500 h-fit w-full absolute",
          {
            "-translate-x-full": index < selectedIndex,
            "translate-x-0": index === selectedIndex,
            "translate-x-full": index > selectedIndex,
          }
        )}
      >
        <div className="w-full">
          {showRecruiter && !loading && open && <RecruiterSelector />}
          <MyComponent
            navigation={{ navigate, goBack, goNext, route }}
            route={{ params: selectedParams }}
            {...item.props}
            open={open}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="flex relative">
      {components?.map((item, index) => renderComponent(item, index))}
    </div>
  );
};

export default SlideStack;
